// extracted by mini-css-extract-plugin
export default {"input":"LimiteFilter_input__xPBJR","label":"LimiteFilter_label__VN-lG"};